export interface FundingCreatePayload {
    accountId: string
    currencyId: string
    amount: number
    reference: string
    fundingMethod: string
}

export interface FundingUpdatePayload {
    status: string
    fundingId: string
}

export interface FundingRetrieve {
    status: string
    id: string
}

export interface FundingStatus {
    value: string
    description: string
}

export default class Funding {
    static statuses: Array<FundingStatus> = [
        {
            value: 'pending',
            description: 'Pending',
        },
        {
            value: 'completed',
            description: 'Completed',
        },
        {
            value: 'failed',
            description: 'Failed',
        },
    ]
}
